import React, { Component } from "react";
import { Formik, Field, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import discordLogo from '../img/DiscordLogo.svg'
import twitchLogo from '../img/TwitchLogo.svg'

class LogIn extends Component {
    constructor(props) {
        super(props);
        this.state = {
            displayRegister: false,
            email: '',
            password: '',
            passwordCheck: '',
            username: ''
        }
        this.switchForm = this.switchForm.bind(this);
    }

    render() {
        let justRegistered;
        if (this.props.userJustRegistered) {
            justRegistered = <p className="formValidation">Vous êtes désormais inscrit ! <button onClick={this.switchForm}>Veuillez vous connecter</button></p>;
        } else { justRegistered = '' }

        let loginError;
        if (this.props.loginError === 'user' || this.props.loginError === 'password') {
            loginError = <p className="formError">L'adresse mail et le mot de passe ne coïncident pas.</p>
        } else if (this.props.loginError === 'unknown') {
            loginError = <p className="formError">Erreur inconnue</p>
        }

        if (!this.state.displayRegister) { // Log in form
            return (
                <div className="logForm">
                    <h2>Embarquer</h2>
                    {loginError}
                    <div className='usernameLogin'>
                        <Formik
                            initialValues={{ username: '', password: '' }}
                            validationSchema={Yup.object({
                                username: Yup.string()
                                    .required('Veuillez renseigner un nom d\'utilisateur.'),
                                password: Yup.string()
                                    .required('Veuillez renseigner un mot de passe')
                            })}
                            onSubmit={(values) => {
                                this.props.submitLogin(values);
                            }}>
                            <Form>
                                <div className="content">
                                    <span className="formLabels">
                                        <label htmlFor="username">Nom d'utilisateur</label><br />
                                        <label htmlFor="password">Mot de passe</label>
                                    </span>
                                    <span className="formInputs">
                                        <Field name="username" type="text" placeholder="Capitaine"></Field><br />
                                        <Field name="password" type="password" placeholder="Mot de passe"></Field>
                                    </span><br />
                                </div>
                                <input type="submit" value="Embarquer !" />
                                <div className="formError">
                                    <p><ErrorMessage name="username" /></p>
                                    <p><ErrorMessage name="password" /></p>
                                </div>
                            </Form>
                        </Formik>
                        <button onClick={this.switchForm}>Pas encore de compte ? S'inscrire.</button>
                    </div>
                    <hr />
                    <div className="socialLogin">
                        <a href={this.props.serverUrl + "auth/discord"} className='discord'>
                            <img src={discordLogo} alt='Discord' />
                            <span>Se connecter avec Discord</span>
                        </a>
                        <br />

                        <a href={this.props.serverUrl + "auth/twitch"} className='twitch'>
                            <img src={twitchLogo} alt='Twitch' />
                            <span>Se connecter avec Twitch</span>
                        </a>
                    </div>
                </div>
            );
        } else { // Register form
            return (
                <div className="logForm">
                    <h2>S'inscrire</h2>
                    {justRegistered}
                    <Formik
                        initialValues={{ email: '', password: '', passwordCheck: '', username: '', }}
                        validationSchema={Yup.object({
                            email: Yup.string()
                                .email('Adresse mail invalide')
                                .required('Veuillez renseigner une adresse mail'),
                            username: Yup.string()
                                .max(20, 'Nom d\'utilisateur trop long.')
                                .min(2, 'Nom d\'utilisateur trop court.')
                                .required('Veuillez renseigner un nom d\'utilisateur.'),
                            password: Yup.string()
                                .required('Veuillez renseigner un mot de passe.'),
                            passwordCheck: Yup.string()
                                .oneOf([Yup.ref('password'), null], 'Les mots de passe ne sont pas identiques.')
                                .required('Veuillez confirmer votre mot de passe.')
                        })}
                        onSubmit={(values) => {
                            this.props.submitRegister(values);
                        }}>
                        <Form>
                            <div className="content">
                                <span className="formLabels">
                                    <label htmlFor="username">Nom d'utilisateur</label><br />
                                    <label htmlFor="email">Email</label><br />
                                    <label htmlFor="password">Mot de passe</label><br />
                                    <label htmlFor="passwordCheck">Confirmation du mot de passe</label>
                                </span>
                                <span className="formInputs">
                                    <Field name="username" type="text" placeholder="Capitaine"></Field><br />
                                    <Field name="email" type="text" placeholder="email@address.com"></Field><br />
                                    <Field name="password" type="password" placeholder="Mot de passe"></Field><br />
                                    <Field name="passwordCheck" type="password" placeholder="Mot de passe"></Field>
                                </span><br />
                            </div>
                            <div className="formError">
                                <p><ErrorMessage name="username" /></p>
                                <p><ErrorMessage name="email" /></p>
                                <p><ErrorMessage name="password" /></p>
                                <p><ErrorMessage name="passwordCheck" /></p>
                            </div>
                            <input type="submit" value="S'inscrire" />
                        </Form>
                    </Formik><br />
                    <button onClick={this.switchForm}>Pas encore de compte ? S'inscrire.</button>
                </div>
            );
        }
    }
    switchForm() {
        this.setState({ displayRegister: !this.state.displayRegister ? true : false });
    }
}


export default LogIn;
